// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aM8fNjELggs5GEPgxx7q{padding-left:24px;padding-right:24px}.sIZCcE0aUVIvUs13fbEf{padding-top:20px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"presetGrid": `aM8fNjELggs5GEPgxx7q`,
	"footer": `sIZCcE0aUVIvUs13fbEf`
};
export default ___CSS_LOADER_EXPORT___;
